module.exports = "/packs/images/icons/icon-play-db843116a6b9044797692eb2782fe1da.svg";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/images/icons/icon-play.svg
// module id = 1792
// module chunks = 0